import { render, staticRenderFns } from "./main-image-card.vue?vue&type=template&id=a00c88e0&scoped=true&"
import script from "./main-image-card.vue?vue&type=script&lang=js&"
export * from "./main-image-card.vue?vue&type=script&lang=js&"
import style0 from "./main-image-card.vue?vue&type=style&index=0&id=a00c88e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c88e0",
  null
  
)

export default component.exports